import {Button, Typography } from "@mui/material"
import IconButton from '@mui/material/IconButton';
import { useState } from "react";
import { loginAdmin } from "../../helperFunctions/api";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';



export default function LoginButton() {

  const [password, setPassword] = useState('');
  const [open, setOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [pending, setPending] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleClickOpen = () => {
    setError("");
    setOpen(true);
  };

  const handleClose = () => {
    if (pending) return;
    setPassword("");
    setOpen(false);
  };

  const handleEnter = (e) =>{
    if(e.key === "Enter"){
      handleLogin()
    }
  }

  const handleLogin = async () => {
    if (pending) return;
    setPending(true);
    setError("");
    try {
      await loginAdmin(password);
      setOpen(false);
    } catch (err) {
      console.error("Admin login failed:", err.message);
      setError(err.message);
    } finally {
      setPassword("");
      setPending(false);
    }
  };

  return (
    <>
      <Button onClick={() => handleClickOpen()} color="inherit">
        Login
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Enter Password</DialogTitle>
        <DialogContent>
          <DialogContentText component="div">
          <FormControl sx={{ m: 1, width: '25ch' }} variant="outlined">
          <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
          <OutlinedInput
            onChange={(e) => setPassword(e.target.value)}
            onKeyPress={handleEnter}
            id="outlined-adornment-password"
            type={showPassword ? 'text' : 'password'}
            value={password}
            autoComplete="current-password"
            disabled={pending}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            label="Password"
          />
        </FormControl>
        {error && <Typography role="alert" color="error" variant="caption">{error}</Typography>}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button disabled={pending || !password} onClick={handleLogin}>{pending ? "Logging in..." : "Login"}</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
